export const setup = config => {
  const q = window;
  if (q.qp) return;
  const n = (q.qp = function () {
    n.qp ? n.qp.apply(n, arguments) : n.queue.push(arguments);
  });
  n.queue = [];
  window.qp('init', config.id);
  window.qp('track', 'ViewContent');
};

/**
 * @description Injects quora pixel script in the DOM
 * @see [quora pixel](https://www.quora.com/ads/pixel)
 * @see [how to install quora pixel](https://quoraadsupport.zendesk.com/hc/en-us/articles/115010466208-How-do-I-install-the-Quora-pixel-)
 */
export const load = (config, onLoad, onError) => {
  const e = 'script';
  const v = 'https://a.quora.com/qevents.js';
  const t = document.createElement(e);
  t.async = !0;
  t.src = v;
  if (onLoad) {
    t.onload = t.onreadystatechange = onLoad;
    t.onabort = onError || onLoad;
    t.onerror = onError || onLoad;
  }
  const s = document.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);

  return window.qp;
};
